import styled from 'styled-components';

export const NoRecordsWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 3%;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.primary}36;
  font-size: 35px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 20pt;
    margin-top: 20%;
  }
`;

export const MainContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  margin-bottom: 15px;
  padding: 0 50px;
  flex-wrap: wrap;
  box-sizing: border-box;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin: 0;
    padding: 0;
    flex-wrap: wrap;
  }
`;

export const TableContainer = styled.div<{ marginBottom?: string }>`
  margin: 0 auto;
  width: 100%;
  height: 90%;
  display: flex;
  margin-top: 15px;
  margin-bottom: ${(props) => props.marginBottom ?? '0px'};
  flex-direction: column;
  justify-content: flex-start;
  max-width: 1200px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 95%;
  }

  ${(props) => props.theme.breakpoints.up('lg')} {
    max-width: 100%;
  }
`;

export const TableSpan = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 20px;
  max-width: 1200px;

  h2 {
    font-size: 15px;
    margin: 0;
    padding: 0;
    font-weight: bold;
  }
`;
